exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.iframe-container-preloader iframe{\n  background: transparent;\n}\n.iframe-container-preloader{\n  background-image: url('/images/Spinner-1s-200px.gif');\n  background-size: 150px 150px;\n  background-position: center 50px;\n  background-repeat: no-repeat;\n  display: block;\n  /*position: absolute;*/\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  min-height: 350px;\n}\n", ""]);

// exports
